import * as api from '../api/dashboard';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const START = 'START';
export const SUCCESS = 'SUCCESS';
export const ERROR = 'ERROR';

export function createRequestTypes(base) {
  return [START, SUCCESS, ERROR].reduce((acc, type) => {
    acc[type] = `${base}_${type}`;
    return acc;
  }, {});
}

const prefix = 'LITIGATION_DASHBOARD';

export const SET_UPCOMING_FILTER = `${prefix}/SET_UPCOMING_FILTER`;

export const setUpcomingFilter = data => ({
  type: SET_UPCOMING_FILTER,
  payload: data,
});

export const SET_CASE_STATUS_FILTER = `${prefix}/SET_CASE_STATUS_FILTER`;

export const setCaseStatusFilter = data => ({
  type: SET_CASE_STATUS_FILTER,
  payload: data,
});

export const SET_SELECTED_DASHBOARD_YEAR = `${prefix}/SET_SELECTED_DASHBOARD_YEAR`;

export const setSelectedDashboardYear = data => ({
  type: SET_SELECTED_DASHBOARD_YEAR,
  payload: data,
});

export const SET_SEARCH_MODIFIER = `${prefix}/SET_SEARCH_MODIFIER`;

export function setSearchModifier(data) {
  return async dispatch => {
    dispatch({ type: SET_SEARCH_MODIFIER, data: data });
  };
}

export const DASHBOARD_GET_PROP_USE_DATA = createRequestTypes(
  `${prefix}/DASHBOARD_GET_PROP_USE_DATA`,
);

export const getPropUseData = makeApiActionCreatorV3(
  api.getPropUseData,
  DASHBOARD_GET_PROP_USE_DATA[START],
  DASHBOARD_GET_PROP_USE_DATA[SUCCESS],
  DASHBOARD_GET_PROP_USE_DATA[ERROR],
);

export const DASHBOARD_GET_TOTAL_CASES = createRequestTypes(
  `${prefix}/DASHBOARD_GET_TOTAL_CASES`,
);

export const getTotalCases = makeApiActionCreatorV3(
  api.getTotalCases,
  DASHBOARD_GET_TOTAL_CASES[START],
  DASHBOARD_GET_TOTAL_CASES[SUCCESS],
  DASHBOARD_GET_TOTAL_CASES[ERROR],
);

export const DASHBOARD_GET_UPCOMING = createRequestTypes(
  `${prefix}/DASHBOARD_GET_UPCOMING`,
);

export const getUpcoming = makeApiActionCreatorV3(
  api.getUpcoming,
  DASHBOARD_GET_UPCOMING[START],
  DASHBOARD_GET_UPCOMING[SUCCESS],
  DASHBOARD_GET_UPCOMING[ERROR],
);

export const DASHBOARD_GET_UPCOMING_STANDALONE = createRequestTypes(
  `${prefix}/DASHBOARD_GET_UPCOMING_STANDALONE`,
);

export const getUpcomingStandalone = makeApiActionCreatorV3(
  api.getUpcoming,
  DASHBOARD_GET_UPCOMING_STANDALONE[START],
  DASHBOARD_GET_UPCOMING_STANDALONE[SUCCESS],
  DASHBOARD_GET_UPCOMING_STANDALONE[ERROR],
);

export const DASHBOARD_GET_STATUS_BREAKDOWN = createRequestTypes(
  `${prefix}/DASHBOARD_GET_STATUS_BREAKDOWN`,
);

export const getStatusBreakdown = makeApiActionCreatorV3(
  api.getStatusBreakdown,
  DASHBOARD_GET_STATUS_BREAKDOWN[START],
  DASHBOARD_GET_STATUS_BREAKDOWN[SUCCESS],
  DASHBOARD_GET_STATUS_BREAKDOWN[ERROR],
);

export const DASHBOARD_GET_TIMELINE = createRequestTypes(
  `${prefix}/DASHBOARD_GET_TIMELINE`,
);

export const getTimeline = makeApiActionCreatorV3(
  api.getTimeline,
  DASHBOARD_GET_TIMELINE[START],
  DASHBOARD_GET_TIMELINE[SUCCESS],
  DASHBOARD_GET_TIMELINE[ERROR],
);

export const DASHBOARD_GET_PROPTYPES = createRequestTypes(
  `${prefix}/DASHBOARD_GET_PROPTYPES`,
);

export const getPropTypes = makeApiActionCreatorV3(
  api.getPropTypes,
  DASHBOARD_GET_PROPTYPES[START],
  DASHBOARD_GET_PROPTYPES[SUCCESS],
  DASHBOARD_GET_PROPTYPES[ERROR],
);

export const DASHBOARD_GET_DETAIL = createRequestTypes(
  `${prefix}/DASHBOARD_GET_DETAIL`,
);

export const getDashboardDetail = makeApiActionCreatorV3(
  api.getDashboardDetail,
  DASHBOARD_GET_DETAIL[START],
  DASHBOARD_GET_DETAIL[SUCCESS],
  DASHBOARD_GET_DETAIL[ERROR],
);

export const SET_DASHBOARD_DATE = `${prefix}/SET_DASHBOARD_DATE`;

export function setDashboardDate(data) {
  return async dispatch => {
    dispatch({ type: SET_DASHBOARD_DATE, data: data });
  };
}

export const SET_DASHBOARD_APPRAISER = `${prefix}/SET_DASHBOARD_APPRAISER`;

export function setDashboardAppraiser(data) {
  return async dispatch => {
    dispatch({ type: SET_DASHBOARD_APPRAISER, data: data });
  };
}
